// Shared toast notification — used by all tabs that mutate or load data.

type ToastType = 'success' | 'warn' | 'error';

const COLORS: Record<ToastType, string> = {
  success: 'var(--green)',
  warn:    'var(--warn)',
  error:   'var(--red)',
};

export function showToast(msg: string, type: ToastType = 'success'): void {
  const color = COLORS[type];
  const toast = document.createElement('div');
  toast.style.cssText = `position:fixed;bottom:24px;right:24px;background:var(--panel);` +
    `border:1px solid ${color};color:${color};font-family:var(--mono);font-size:12px;` +
    `padding:10px 16px;border-radius:4px;z-index:9999;` +
    `box-shadow:0 4px 20px rgba(0,0,0,0.4);transition:opacity 0.3s;`;
  toast.textContent = msg;
  document.body.appendChild(toast);
  setTimeout(() => {
    toast.style.opacity = '0';
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}
